import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import FadeInWrapper from "../../../../components/common/fade-in-wrapper";
import BottomSheet from "../../../../components/common/bottom-sheet";
import PercentIcon from "./images/percent_icon3.png";
import GraphIcon from "./images/graph_icon2.png";
import SneakersIcon from "./images/sneakers_icon2.png";

export default function NotificationInfoPage() {
  const navigate = useNavigate();
  const [isSheetOpen, setIsSheetOpen] = useState(false);

  const notifications = [
    {
      image: GraphIcon,
      title: "가격인하",
    },
    {
      image: PercentIcon,
      title: "반값할인 오픈",
    },
    {
      image: SneakersIcon,
      title: "헛걸음 방지",
    },
  ];

  const handleNext = () => {
    navigate("/onboarding/notification/request");
  };

  const handleSkip = () => {
    navigate("/onboarding/location");
  };

  return (
    <div className="h-full bg-white min-h-screen relative pb-40 flex flex-col justify-center">
      <div className="w-full">
        <FadeInWrapper className="flex flex-col items-center px-4">
          {/* Header - 가운데 정렬 */}
          <div className="flex flex-col items-center mb-10 text-center">
            <h1 className="text-3xl text-black font-[900] leading-snug">
              절약되는 정보만
              <br />
              딱, 골라 보내드려요
            </h1>
            <p className="text-gray-500 mt-3 text-sm">
              진짜 혜택 알림만 받으세요
            </p>
          </div>
        </FadeInWrapper>

        <FadeInWrapper className="flex flex-col gap-3 px-4 w-full">
          {/* Notification Cards - 세로 리스트 배치 */}
          {notifications.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.1, duration: 0.4 }}
              className="w-full bg-white rounded-[24px] p-5 flex flex-row items-center gap-5 shadow-sm border border-gray-100"
            >
              {/* Icon */}
              <div className="w-14 h-14 flex-shrink-0 flex items-center justify-center bg-gray-50 rounded-2xl p-2">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-contain drop-shadow-sm"
                />
              </div>

              {/* Title */}
              <h3 className="text-[17px] font-bold text-gray-900 leading-tight">
                {item.title}
              </h3>
            </motion.div>
          ))}
        </FadeInWrapper>
      </div>

      {/* 버튼 영역 */}
      <FadeInWrapper className="px-5 py-4 w-full fixed bottom-0 left-0 bg-white flex flex-col gap-3">
        <button
          onClick={handleNext}
          className="w-full h-[60px] flex items-center justify-center rounded-3xl font-bold bg-[#1562fc] text-white text-lg shadow-lg hover:bg-blue-600 transition-colors"
        >
          알림 받고 혜택 챙기기
        </button>
        <button
          onClick={() => setIsSheetOpen(true)}
          className="w-full h-[40px] flex items-center justify-center rounded-xl font-medium text-gray-400 text-sm hover:text-gray-600 transition-colors underline decoration-gray-300 underline-offset-4"
        >
          알림 받지 않을래요
        </button>
      </FadeInWrapper>

      {/* 이탈 방지 바텀시트 */}
      <BottomSheet
        isOpen={isSheetOpen}
        onClose={() => setIsSheetOpen(false)}
        showOverlay={true}
      >
        <div className="px-1 pb-4 pt-2">
          <div className="text-center mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-3 leading-snug">
              혜택을 놓칠 수 있어요! 😱
            </h2>
            <p className="text-gray-500 text-[15px] leading-relaxed">
              지금 알림을 끄면
              <br />
              <span className="text-blue-600 font-bold">선착순 할인 정보</span>
              를 받지 못하게 돼요.
            </p>
          </div>

          <div className="flex flex-col gap-3">
            <button
              onClick={handleNext}
              className="w-full h-[56px] flex items-center justify-center rounded-2xl font-bold bg-[#1562fc] text-white text-lg shadow-md hover:bg-blue-600 transition-colors"
            >
              알림 받을게요!
            </button>
            <button
              onClick={handleSkip}
              className="w-full h-[56px] flex items-center justify-center rounded-2xl font-medium bg-gray-100 text-gray-500 text-lg hover:bg-gray-200 transition-colors"
            >
              알림 안 받을게요
            </button>
          </div>
        </div>
      </BottomSheet>
    </div>
  );
}
